"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayStatus = void 0;
const pay_status_schema_1 = require("./pay-status.schema");
const base_model_1 = require("../base-model");
const utilities_1 = require("../../utilities");
class PayStatus extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    get classification() {
        return (0, utilities_1.determinePayStatusClassificationByType)(this.type);
    }
    getDefaults() {
        return {
            isConfirmed: false,
            isDuplicated: false,
            classification: (0, utilities_1.determinePayStatusClassificationByType)(this.type),
        };
    }
    getSchema() {
        return pay_status_schema_1.payStatusSchema;
    }
}
exports.PayStatus = PayStatus;
